// React
import React from "react";

// Libraries
import PropTypes from "prop-types";
import { Icon } from "semantic-ui-react";
import { get, isEmpty } from "lodash";

// Components
import Text from "@Components/Text";

// Utils
import { getTimeLabel } from "@Utils/functionality";

// Styles
import styles from "./styles.module.css";

const ActionCard = ({ chatAction }) => {
	const group = get(chatAction, "newGroup.name", "");
	const user = get(chatAction, "newUser.fullName", "");
	const from = chatAction?.action === "Assign" ? "newUser.fullName" : "userAction.fullName";
	const actionUser = get(chatAction, from, "");

	const renderIcon = (action) => {
		switch (action) {
			case "Tomar":
				return <Icon className={styles.iconHeader} name="handshake" />;
			case "Liberar":
				return <Icon className={styles.iconHeader} name="recycle" />;
			case "Transferir":
				return <Icon className={styles.iconHeader} name="exchange" />;
			case "Cierre":
				return <Icon className={styles.iconHeader} name="sign out" />;
			case "Asignar":
				return <Icon className={styles.iconHeader} name="user plus" />;
			case "Bloquear":
				return <Icon className={styles.iconHeader} name="ban" />;
			default:
				return null;
		}
	};

	return (
		<div className={styles.container}>
			<div className={styles.header}>
				<div className={styles.iconContainer}>{renderIcon(chatAction.action)}</div>
				<div className={styles.action}>
					<Text className={styles.actionText}>{chatAction.action}</Text>
				</div>
				<div className={styles.date}>
					<Text className={styles.dateText}>{getTimeLabel(chatAction.timestamp, "D/M/Y h:mm A")}</Text>
				</div>
			</div>
			<div className={styles.content}>
				<Text className={styles.text}>{actionUser}</Text>
				{chatAction.action === "Transferir" && (
					<>
						<div className={styles.arrow}>
							<Icon name="arrow down" />
						</div>
						{!isEmpty(group) && <Text className={styles.text}>{group}</Text>}
						{!isEmpty(user) && <Text className={styles.text}>{user}</Text>}
					</>
				)}
				{chatAction.action === "Bloquear" && (
					<>
						<Text className={styles.text}>{"Bloqueo de palabra clave: "}</Text>
						<div className={styles.arrow}>
							<Icon name="arrow down" />
						</div>
						<Text className={styles.text}>{chatAction.extra}</Text>
					</>
				)}
			</div>
		</div>
	);
};

ActionCard.propTypes = {
	chatAction: PropTypes.object.isRequired,
};

export default ActionCard;
